import queryString from 'query-string';

import { pick } from 'helpers/utils/pick';

export type PrivateAlbumParams = {
  photo: string | null;
  userId: number;
};
export const privateAlbumParams: (keyof PrivateAlbumParams)[] = [
  'photo',
  'userId',
];

export type MessageParams = {
  photo: string | null;
  username: string;
  userId: number;
};
export const messageParams: (keyof MessageParams)[] = [
  'photo',
  'username',
  'userId',
];

export type FailMessageParams = {
  photo: string | null;
  username: string;
  userId: number;
  messageId: number;
};
export const failMessageParams: (keyof FailMessageParams)[] = [
  'photo',
  'username',
  'userId',
  'messageId',
];

export type ActivityLikeParams = {
  photo: string | null;
  userId: number | null;
};
export const activityLikeParams: (keyof ActivityLikeParams)[] = [
  'photo',
  'userId',
];

export type ActivityVisitParams = {
  photo: string | null;
  userId: number | null;
};

export const activityVisitParams: (keyof ActivityVisitParams)[] = [
  'photo',
  'userId',
];

export type ActivityMatchParams = {
  photo: string | null;
  userId: number;
  username: string;
};

export const activityMatchesParams: (keyof ActivityMatchParams)[] = [
  'photo',
  'userId',
  'username',
];

export type PhotoMessageParams = {
  photo: string | null;
  userId: number;
};

export const photoMessageParams: (keyof PhotoMessageParams)[] = [
  'photo',
  'userId',
];

export type UserProfileParams = {
  userId: number;
  username: string;
  photo: string | null;
};

export const userProfileParams: (keyof UserProfileParams)[] = [
  'userId',
  'username',
  'photo',
];

export type StickerMessageParams = {
  photo: string | null;
  userId: number;
  stickerPackId: number | null;
};

export type StickerMessageV2Params = {
  userId: number;
  stickerId: number;
  stickerPackId: number;
};

export const stickerMessageParams: (keyof StickerMessageParams)[] = [
  'photo',
  'userId',
  'stickerPackId',
];

export type PrivateVideoParams = {
  userId: number;
  videoId: number;
};

export const privateVideoParams: (keyof PrivateVideoParams)[] = [
  'userId',
  'videoId',
];

export type FunnelsParams = PrivateAlbumParams &
  MessageParams &
  FailMessageParams &
  ActivityLikeParams &
  ActivityVisitParams &
  ActivityMatchParams &
  PhotoMessageParams &
  StickerMessageParams &
  PrivateVideoParams &
  UserProfileParams;

export const funnelsParams: (keyof FunnelsParams)[] = [
  ...privateAlbumParams,
  ...messageParams,
  ...failMessageParams,
  ...activityLikeParams,
  ...activityVisitParams,
  ...activityMatchesParams,
  ...photoMessageParams,
  ...stickerMessageParams,
  ...privateVideoParams,
  ...userProfileParams,
];

export enum Funnels {
  ActivityLike = 'activity_like',
  ActivityMatches = 'activity_matches',
  ActivityVisit = 'activity_visit',
  BannerMessage = 'banner_messagе',
  BlurMessage = 'blur_message',
  EditProfile = 'editprofile',
  FinderButton = 'finder_button',
  FinderLimit = 'finder_limit',
  GeneralButton = 'general_button',
  HardPayment = 'hard_payment',
  IntroSkip = 'intro_skip',
  XSkip = 'x_skip',
  LikesButton = 'likes_button',
  LimitOffer = 'limit_offer',
  MatchFullScreen = 'perfect_match_fullScreen',
  Matches = 'matches',
  Message = 'message',
  MessageFailed = 'message_failed',
  MyProfileButton = 'my_profile_button',
  MyProfileCarousel = 'myprofile_carousel',
  MyProfileGetButton = 'myprofile_get_button',
  MyProfilePremiumButton = 'myprofile_premium_button',
  NonSkip = 'non_skip',
  NonSkip5Min = 'non_skip_5m',
  Notifications = 'notifications',
  NotificationsLikes = 'notifications_likes',
  PhotoMessage = 'photo_message',
  PrivateAlbum = 'private_album',
  ProfileBanner = 'profilebanner',
  ProfileUnlock = 'profile_unlock',
  RevealLikes = 'reveal_likes',
  RevealVisits = 'reveal_visits',
  StartDayTrial = 'start_day_trial',
  StickerMessage = 'sticker_message',
  StickerMessageV2 = 'sticker_message_v2',
  StickyGift = 'sticky_gift',
  StopExit = 'stop_exit',
  ThreadsButton = 'threads_button',
  VideoNotifications = 'videonotification',
  WelcomeMessage = 'welcome_message',
}

export enum CreditsFunnels {
  Boost = 'boost',
  FinderBanner = 'finder_banner',
  FinderPreview = 'finder_preview',
  Gift = 'gift',
  MyProfile = 'my_profile',
  PayMessages = 'pay_messages',
  ProfileVideo = 'profile_video',
  ThreadsBanner = 'threads_banner',
  VideoCast = 'video_cast',
  WelcomeGift = 'welcome_pack',
}

// * FUNNELS

export function getFunnelSearchString(
  funnel: Funnels.ActivityLike,
  params: ActivityLikeParams
): string;
export function getFunnelSearchString(
  funnel: Funnels.ActivityMatches,
  params: ActivityMatchParams
): string;
export function getFunnelSearchString(
  funnel: Funnels.ActivityVisit,
  params: ActivityVisitParams
): string;
export function getFunnelSearchString(
  funnel: Funnels.BannerMessage,
  params: MessageParams
): string;
export function getFunnelSearchString(
  funnel: Funnels.BlurMessage,
  params: MessageParams
): string;
export function getFunnelSearchString(
  funnel: Funnels.EditProfile,
  params?: undefined
): string;
export function getFunnelSearchString(
  funnel: Funnels.FinderButton,
  params?: undefined
): string;
export function getFunnelSearchString(
  funnel: Funnels.FinderLimit,
  params?: undefined
): string;
export function getFunnelSearchString(
  funnel: Funnels.GeneralButton,
  params?: undefined
): string;
export function getFunnelSearchString(
  funnel: Funnels.HardPayment,
  params?: undefined
): string;
export function getFunnelSearchString(
  funnel: Funnels.IntroSkip,
  params?: undefined
): string;
export function getFunnelSearchString(
  funnel: Funnels.XSkip,
  params?: undefined
): string;
export function getFunnelSearchString(
  funnel: Funnels.LikesButton,
  params?: undefined
): string;
export function getFunnelSearchString(
  funnel: Funnels.LimitOffer,
  params?: undefined
): string;
export function getFunnelSearchString(
  funnel: Funnels.Matches,
  params?: undefined
): string;
export function getFunnelSearchString(
  funnel: Funnels.MatchFullScreen,
  params: MessageParams
): string;
export function getFunnelSearchString(
  funnel: Funnels.Message,
  params: MessageParams
): string;
export function getFunnelSearchString(
  funnel: Funnels.Message,
  params: FailMessageParams
): string;
export function getFunnelSearchString(
  funnel: Funnels.MessageFailed,
  params: FailMessageParams
): string;
export function getFunnelSearchString(
  funnel: Funnels.MyProfileButton,
  params?: undefined
): string;
export function getFunnelSearchString(
  funnel: Funnels.MyProfileCarousel,
  params?: undefined
): string;
export function getFunnelSearchString(
  funnel: Funnels.MyProfileGetButton,
  params?: undefined
): string;
export function getFunnelSearchString(
  funnel: Funnels.MyProfilePremiumButton,
  params?: undefined
): string;
export function getFunnelSearchString(
  funnel: Funnels.NonSkip,
  params?: undefined
): string;
export function getFunnelSearchString(
  funnel: Funnels.NonSkip5Min,
  params?: undefined
): string;
export function getFunnelSearchString(
  funnel: Funnels.Notifications,
  params?: undefined
): string;
export function getFunnelSearchString(
  funnel: Funnels.NotificationsLikes,
  params?: undefined
): string;
export function getFunnelSearchString(
  funnel: Funnels.PhotoMessage,
  params: PhotoMessageParams
): string;
export function getFunnelSearchString(
  funnel: Funnels.PrivateAlbum,
  params: PrivateAlbumParams
): string;
export function getFunnelSearchString(
  funnel: Funnels.ProfileBanner,
  params?: undefined
): string;
export function getFunnelSearchString(
  funnel: Funnels.ProfileUnlock,
  params: UserProfileParams
): string;
export function getFunnelSearchString(
  funnel: Funnels.RevealLikes,
  params?: undefined
): string;
export function getFunnelSearchString(
  funnel: Funnels.RevealVisits,
  params?: undefined
): string;
export function getFunnelSearchString(
  funnel: Funnels.StartDayTrial,
  params?: undefined
): string;
export function getFunnelSearchString(
  funnel: Funnels.StickerMessage,
  params?: StickerMessageParams
): string;
export function getFunnelSearchString(
  funnel: Funnels.StickerMessageV2,
  params?: StickerMessageV2Params
): string;
export function getFunnelSearchString(
  funnel: Funnels.StickyGift,
  params?: undefined
): string;
export function getFunnelSearchString(
  funnel: Funnels.StopExit,
  params?: undefined
): string;
export function getFunnelSearchString(
  funnel: Funnels.ThreadsButton,
  params?: undefined
): string;
export function getFunnelSearchString(
  funnel: Funnels.VideoNotifications,
  params?: undefined
): string;
export function getFunnelSearchString(
  funnel: Funnels.WelcomeMessage,
  params?: undefined
): string;

// * CREDITS FUNNELS
export function getFunnelSearchString(
  funnel: CreditsFunnels,
  params?: any
): string;

// * FUNNELS
export function getFunnelSearchString(
  funnel: Funnels | CreditsFunnels,
  params?: Record<string, string | number | null>
): string {
  return queryString.stringify({
    funnel,
    ...(Boolean(params) && params),
  });
}

export function getFunnelsSearchParams(search: string) {
  const searchParams = queryString.parse(search);

  return pick(funnelsParams, searchParams) as Partial<FunnelsParams>;
}
